import * as React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"

import "../components/main.css"


const PrivacyPolicy = () => (
    <Layout>
        <h1 class="menuHeader">Privacy Policy</h1>
        <div class="privacyWrapper">
            <h1 style={{ textAlign: "center", fontSize: "1.5em" }}>OUR PRIVACY POLICIES AND PRACTICES</h1>

            <h2>What Information Do We Collect?</h2>
            <p>We collect information from you when you fill out a form. You may be asked to enter your name, e-mail address, mailing address, or phone number. You may, however, visit our site anonymously.</p>

            <h2>What Do We Use Your Information For?</h2>
            <p>Any of the information we collect from you may be used in one of the following ways:</p>
            <ul>
                <li><strong>To process transactions:</strong> Your information, whether public or private, will not be sold, exchanged, transferred, or given to any other company for any reason whatsoever, without your consent, other than for the express purpose of delivering the purchased product or service requested.</li>
                <li><strong>To send periodic emails:</strong> The email address you provide will only be used to send you information and updates pertaining to the request you submitted online.</li>
            </ul>

            <h2>How Do We Protect Your Information?</h2>
            <p>We implement a variety of security measures to maintain the safety of your personal information when you place an order or access your personal information.</p>

            <h2>Do We Disclose Any Information to Outside Parties?</h2>
            <p>We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information. This does not include trusted third parties who assist us in operating our website, conducting our business, or servicing you, so long as those parties agree to keep this information confidential. We may also release your information when we believe release is appropriate to comply with the law, enforce our site policies, or protect ours or others’ rights, property, or safety. However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.</p>

            <h2>Third-Party Links</h2>
            <p>Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We, therefore, have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.</p>

            <h2>Children’s Online Privacy Protection Act Compliance</h2>
            <p>We are in compliance with the requirements of COPPA (<strong>Children’s Online Privacy Protection Act</strong>); we do not collect any information from anyone under 13 years of age. Our website, products, and services are all directed to people who are at least 13 years old or older.</p>

            <h2>Your Consent</h2>
            <p>By using our site, you consent to our privacy policy.</p>

            <h2>Changes to Our Privacy Policy</h2>
            <p>If we decide to change our privacy policy, we will post those changes on this page.</p>

            <h2>Contacting Us</h2>
            <p>If you have any questions regarding this privacy policy, you may contact us at:</p>
            <p><strong>Beth Rogers Agency, Inc.</strong></p><p>4072 West Henrietta Rd.</p><p>Rochester NY 14623 </p><p>Email: <a href="mailto:beth@bethrogersagency.com">beth@bethrogersagency.com</a></p>

        </div>
    </Layout>
)

export default PrivacyPolicy